import { render, staticRenderFns } from "./StorageConfiguration.vue?vue&type=template&id=6d33f91d&scoped=true"
import script from "./StorageConfiguration.vue?vue&type=script&lang=js"
export * from "./StorageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./StorageConfiguration.vue?vue&type=style&index=0&id=6d33f91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33f91d",
  null
  
)

export default component.exports